import { Fragment, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import "../pages/CompleteService/ReviewCompletionStatus.scss";
import "./MyTabCits.scss";
import MyTabDetail from "./MyTabDetail";

function MyTabCits({ getData, menuData, category }) {
  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  });
  let navigate = useNavigate();
  return (
    <div className="">
      <div className="">
        {/* <form className="my_page bbs_contain" action="" method=""> */}
        <Routes>
          <Route
            path=":id"
            element={<MyTabDetail menuData={menuData} category={category} />}
          />
        </Routes>
        <div className="row_bbs bbs_customqa_wrap">
          <table className="table_wrap_customerqa">
            <thead>
              <tr>
                <th style={{ flex: "0.4" }}>심사명</th>
                <th style={{ flex: "0.3" }}>접수/인증번호</th>
                <th style={{ flex: "0.3" }}>신청구분</th>
                <th style={{ flex: "0.2" }}>접수일</th>
                <th style={{ flex: "0.6" }}>진행단계</th>
              </tr>
            </thead>
            <tbody>
              {getData.map((e, idx) => {
                return (
                  <Fragment key={idx}>
                    <tr
                      key={e.id}
                      className={e.state === 10 ? "tr_hover_fin" : "tr_hover"}
                    >
                      <td style={{ flex: "0.4" }}>
                        <p className="auth">{e.taskGroup?.workflowName}</p>
                      </td>
                      {e.acceptNum !== null ? (
                        <td
                          className="num_bbs"
                          style={{
                            color: "dodgerBlue",
                            cursor: "pointer",
                            flex: "0.3",
                          }}
                          onClick={() =>
                            navigate(`/breakdown/cits/${e.id}`, {
                              state: e.id,
                            })
                          }
                        >
                          {e.qualificationNum === null ||
                          e.qualificationNum === "" ? (
                            <>{e.acceptNum}</>
                          ) : (
                            <>{e.qualificationNum}</>
                          )}
                        </td>
                      ) : (
                        <td
                          className="num_bbs"
                          style={{
                            color: "dodgerBlue",
                            cursor: "pointer",
                            flex: "0.3",
                          }}
                          onClick={() =>
                            navigate(`/breakdown/cits/${e.id}`, {
                              state: e.id,
                            })
                          }
                        >
                          접수전
                        </td>
                      )}

                      <td style={{ flex: "0.3" }}>
                        {e.taskGroup?.type === 1 ? <p>신규</p> : null}
                        {e.taskGroup?.type === 2 ? <p>정기심사</p> : null}
                        {e.taskGroup?.type === 3 ? <p>재평가</p> : null}
                        {e.taskGroup?.type === 4 ? <p>추가</p> : null}
                        {e.taskGroup?.type === 5 ? <p>변경</p> : null}
                        {e.taskGroup?.type === 6 ? <p>재발급</p> : null}
                        {e.taskGroup?.type === 7 ? <p>지위승계</p> : null}
                        {e.taskGroup?.type === 9 ? <p>이의불만분쟁</p> : null}
                      </td>

                      <td style={{ flex: "0.2" }} className="date_bbs">
                        {e.acceptDate?.substring(0, 11).replace(/-/g, ".")}
                      </td>

                      {/* {e.state === 10 ? (
                          <td style={{ flex: "0.6" }}>
                            <b>인증심사완료</b>
                          </td>
                        ) : (
                          <td style={{ flex: "0.6" }} className="date_bbs">
                            {e.state === 9 ? (
                              "심사기관취소"
                            ) : (
                              <>
                                {e.state === 50 ? (
                                  "추가신청진행중"
                                ) : (
                                  <>
                                    {e.state === 22 ? (
                                      "심사기관중지"
                                    ) : (
                                      <>
                                        <>
                                          {e.state === 21 ? (
                                            "효력정지"
                                          ) : (
                                            <>{e.taskName}</>
                                          )}
                                        </>
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </td>
                        )} */}
                      <td style={{ flex: "0.6" }}>
                        {e.state === 9 ? "심사기관취소" : null}
                        {e.state === 10 ? <b>인증심사완료</b> : null}
                        {e.state === 21 ? "효력정지" : null}
                        {e.state === 22 ? "심사기관중지" : null}
                        {e.state === 99 && "신청기관취소"}
                        {e.state === 50 ? (
                          <>
                            {e.ingType === 1 ? "신규신청 진행중" : null}
                            {e.ingType === 2 ? "정기심사신청 진행중" : null}
                            {e.ingType === 3 ? "재평가신청 진행중" : null}
                            {e.ingType === 4 ? "추가신청 진행중" : null}
                            {e.ingType === 5 ? "변경신청 진행중" : null}
                            {e.ingType === 6 ? "재발급신청 진행중" : null}
                          </>
                        ) : null}
                        {e.state === 9 ||
                        e.state === 10 ||
                        e.state === 21 ||
                        e.state === 22 ||
                        e.state === 50 ||
                        e.state === 99
                          ? null
                          : e.taskName}
                      </td>
                    </tr>
                  </Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* </form> */}
      </div>
    </div>
  );
}

export default MyTabCits;
